<template>
    <el-form-item :label="$t.__('companysearch.GB_form.company_name')" prop="search">
        <el-input
            prop="search"
            @keyup.enter.native="$emit('search-companies')"
            :disabled="!providerEnabled"
            id="search"
            class="valign-middle"
            :class="{ 'w-5': inline }"
            v-model="form.search"
            :placeholder="$t.__('companysearch.GB_form.enter_company_informations')"
        />
    </el-form-item>
</template>
<script>
export default {
    props: {
        providerEnabled: {
            type: Boolean,
            required: true,
            default: true,
        },
        form: {
            type: Object,
            required: true,
            default: () => {},
        },
        inline: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
};
</script>
